module.exports = __webpack_public_path__ + "img/Responsiveness.0fb29bdc.gif";